var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMineClassSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_class_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u8BFE\\u5802",
    transform: "translate(-230, -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_class_selected",
    transform: "translate(230, 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFA516",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(9.3402, 8.2069)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 17.5862069,
    height: 17.5862069
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(0, 3.5172)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5026555,12.4568966 L2.62222906,12.4568966 C1.17568504,12.4568966 0,11.2758771 0,9.82276965 L0,2.63412691 C0,1.18101947 1.17568504,0 2.62222906,0 L10.5026555,0 C11.9491995,0 13.1248845,1.18101947 13.1248845,2.63412691 L13.1248845,9.8247413 C13.1248845,11.2758771 11.9491995,12.4568966 10.5026555,12.4568966 Z M2.62222906,1.76660008 C2.14724446,1.76660008 1.75862069,2.1550155 1.75862069,2.63412691 L1.75862069,9.8247413 C1.75862069,10.3018811 2.14528171,10.6922681 2.62222906,10.6922681 L10.5026555,10.6922681 C10.9776401,10.6922681 11.3662639,10.3038527 11.3662639,9.8247413 L11.3662639,2.63412691 C11.3662639,2.15698715 10.9796028,1.76660008 10.5026555,1.76660008 L2.62222906,1.76660008 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9512392,10.6686083 C15.7353371,10.6686083 15.5174723,10.625232 15.3094212,10.5365076 L11.9001308,9.07748524 C11.5762777,8.93946961 11.3643011,8.61809035 11.3643011,8.26516466 L11.3643011,4.19370354 C11.3643011,3.8388062 11.574315,3.5193986 11.9001308,3.38138297 L15.3094212,1.92236058 C15.813847,1.70547887 16.3908944,1.75871347 16.8521398,2.06234786 C17.3114224,2.3679539 17.5862069,2.88058339 17.5862069,3.43264592 L17.5862069,9.02425064 C17.5862069,9.57828481 17.3114224,10.0889426 16.8521398,10.3945487 C16.5812808,10.5759407 16.2672414,10.6686083 15.9512392,10.6686083 Z M13.1248845,7.68155571 L15.8275862,8.83891536 L15.8275862,3.61995284 L13.1248845,4.7773125 L13.1248845,7.68155571 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79691349,3.82303299 C2.79691349,4.17805229 2.98545853,4.50610366 3.29152555,4.68361332 C3.59759256,4.86112298 3.97468268,4.86112298 4.2807497,4.68361332 C4.58681672,4.50610366 4.77536176,4.17805229 4.77536176,3.82303299 C4.77536176,3.2742207 4.33247103,2.82932044 3.78613762,2.82932044 C3.23980422,2.82932044 2.79691349,3.2742207 2.79691349,3.82303299 L2.79691349,3.82303299 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMineClassSelected);
export default __webpack_public_path__ + "static/media/icon_mine_class_selected.svg";
export { ForwardRef as ReactComponent };